
<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja deletar o depósito <b>{{entry.name}}?</b></p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
  data () {
    return {
      error: null,
      loading: true,
      formErrors: []
    }
  },
  components: {
    BaseDelete: BaseDelete
  },
  props: {
    entry: Object,
    modelNameSingular: String,
  },
  methods: {
    destroyServerEntry: function(storehouse) {
      this.loading = true;
        this.$apollo
          .mutate({
            mutation: DESTROY_STOREHOUSE_MUTATION,
            variables: {
              id: storehouse.id,
            }
          })
          .then(response => {
            var errors = response.data.destroyStorehouse.errors
            if (errors.length){
              this.formErrors = errors
            } else {
              this.$emit("entry-destroyed");
              this.$refs.baseDelete.closeDialog();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
    },
    destroyEntry: function() {
      this.destroyServerEntry(this.entry);
    },
  }
}
const DESTROY_STOREHOUSE_MUTATION = gql `
  mutation($id: ID!) {
    destroyStorehouse(id: $id) {
      storehouse {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>